import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import uuid4 from "uuid";
import style from "./display/style.vue";
import { numberToArray } from "@/util";

// 1 镜千-店铺 2 镜千-个人中心 3 镜千-微页面 4 镜千/云单-商详 5 镜千-hot 6 云单-商城页 7 云单-个人中心 8 云单(网点)-微页面 9 云单(网点组)-微页面 10 云单 hot
enum PAGE {
	SHOP = 1,
	CENTER,
	MINI,
	PRO_INFO,
	HOT,
	CLOUD_MALL_SHOP,
	CLOUD_MALL_CENTER,
	CLOUD_MALL_MINI,
	SG_CLOUD_MALL_MINI,
	CLOUD_HOT,
}

const ButtonList = [
	{
		text: "图文广告",
		key: "Propagate",
		icon: "icon-tuwenguanggao1",
		page: [PAGE.CENTER, PAGE.SHOP, PAGE.MINI, PAGE.CLOUD_MALL_SHOP, PAGE.CLOUD_MALL_CENTER, PAGE.CLOUD_MALL_MINI],
	},
	{ text: "视频", key: "video", icon: "icon-shipin1", page: [PAGE.CENTER, PAGE.SHOP] },
	{
		text: "视频",
		key: "pageVideo",
		icon: "icon-shipin1",
		page: [PAGE.MINI, PAGE.CLOUD_MALL_CENTER, PAGE.CLOUD_MALL_SHOP, PAGE.CLOUD_MALL_MINI, PAGE.SG_CLOUD_MALL_MINI],
	},
	{
		text: "辅助空白",
		key: "blank",
		icon: "icon-fuzhukongbai1",
		page: [PAGE.CENTER, PAGE.SHOP, PAGE.MINI, PAGE.CLOUD_MALL_SHOP, PAGE.CLOUD_MALL_CENTER, PAGE.CLOUD_MALL_MINI, PAGE.SG_CLOUD_MALL_MINI],
	},
	{
		text: "文字标题",
		key: "text",
		icon: "icon-wenzibiaoti1",
		page: [PAGE.CENTER, PAGE.MINI, PAGE.CLOUD_MALL_CENTER, PAGE.CLOUD_MALL_MINI, PAGE.SG_CLOUD_MALL_MINI],
	},
	{ text: "商品橱窗", key: "ShowWindow", icon: "icon-shangpinchuchuang1", page: [PAGE.SHOP, PAGE.MINI, PAGE.CLOUD_MALL_SHOP, PAGE.CLOUD_MALL_MINI] },
	{ text: "期刊橱窗", key: "QiKanShowWindow", icon: "icon-qikanchuchuang1", page: [PAGE.CLOUD_MALL_SHOP] },
	{ text: "多页橱窗", key: "weiGroup", icon: "icon-duoyechuchuang1", page: [PAGE.CLOUD_MALL_SHOP] },
	{ text: "商品搜索", key: "search", icon: "icon-shangpinjiansuo1", page: [PAGE.SHOP, PAGE.MINI, PAGE.CLOUD_MALL_SHOP, PAGE.CLOUD_MALL_MINI] },
	{ text: "分类导航", key: "LabelClass", icon: "icon-fenleidaohang1", page: [PAGE.SHOP, PAGE.MINI, PAGE.CLOUD_MALL_SHOP, PAGE.CLOUD_MALL_MINI] },
	{ text: "图标导航", key: "iconMenu", icon: "icon-tubiaodaohang1", page: [PAGE.CENTER, PAGE.MINI, PAGE.CLOUD_MALL_SHOP, PAGE.CLOUD_MALL_CENTER, PAGE.CLOUD_MALL_MINI] },
	{ text: "悬浮图标", key: "HoverIcon", icon: "icon-xuanfutubiao1", page: [PAGE.SHOP, PAGE.MINI, PAGE.HOT] },
	{ text: "页面设置", key: "miniPage", icon: "", page: [PAGE.MINI, PAGE.CLOUD_MALL_MINI, PAGE.SG_CLOUD_MALL_MINI] },
	{ text: "图片", key: "ProductPicture", icon: "icon-tuwenguanggao1", page: [PAGE.PRO_INFO] }, // 商详用
	{
		text: "添加引导",
		key: "guide",
		icon: "icon-tianjiayindao1",
		page: [PAGE.CENTER, PAGE.SHOP, PAGE.MINI, PAGE.HOT, PAGE.CLOUD_HOT, PAGE.CLOUD_MALL_CENTER, PAGE.CLOUD_MALL_SHOP],
	},
	{ text: "图片", key: "picture", icon: "icon-tuwenguanggao1", page: [PAGE.SG_CLOUD_MALL_MINI] }, // 云单模式下的网点组用
];

@Component({
	components: {},
	mixins: [style],
})
export default class AddButton extends Vue {
	@Prop({ default: () => [] })
	value: Array<any>;

	@Prop()
	fromPage: number;

	getPageName() {
		return this.fromPage == PAGE.SHOP ? "商城页" : this.fromPage == PAGE.CENTER ? "个人中心" : this.fromPage == PAGE.MINI ? "微页面" : "";
	}

	data = [];

	@Watch("value", { deep: true, immediate: true })
	watchValue(n, o) {
		// this.data = (this.$parent as ItemObject).value;
		this.data = n;
	}

	insertBlank(val: ItemArray) {
		val.unshift({
			sort: this.data.length,
			_key: uuid4(),
			isActived: false,
			sgwpId: 7,
			ygswpId: 0,
			fieldType: this.fromPage === PAGE.SHOP ? "Blank" : "blank",
			desc: { bHeight: 24 },
		});
		return val;
	}

	// 添加图文广告
	Propagate() {
		const pName = uuid4();
		/* 此处因为如果删除中间的图文广告，会使得新增的图文广告名称和最后一个图文广告的名称相同导致不能存储 */
		// this.data.filter((v) => {
		//   return v.fieldType == "Propagate";
		// }).length || 0;
		const item = {
			sort: this.data.length,
			isActived: false,
			_key: uuid4(),
			sgwpId: 9,
			ygswpId: 0,
			fieldType: "Propagate",
			desc: {
				// pName: `${this.getPageName()}广告位${pName}`,
				pName: "广告位",
				pWidth: 750,
				pHeight: 300,
				pMaxPage: 5,
				pStyle: 1,
				displayType: 3,
				margin: 16,
				borderRadius: 20,
				list: [],
			},
		};
		this.addItem(this.insertBlank([item]));
	}

	// 添加视频
	video() {
		const vName = this.data.filter((v) => v.fieldType === "video").length + 1;
		const item = {
			sort: this.data.length,
			_key: uuid4(),
			isActived: false,
			sgwpId: 6,
			ygswpId: 0,
			fieldType: "video",
			desc: {
				vName: "视频",
				// vName: this.getPageName() + "视频" + vName,
			},
		};
		this.addItem(this.insertBlank([item]));
	}

	// 添加辅助空白
	blank() {
		this.addItem([
			{
				sort: this.data.length,
				_key: uuid4(),
				isActived: false,
				sgwpId: 7,
				ygswpId: 0,
				fieldType: this.fromPage === PAGE.SHOP || this.fromPage === PAGE.CLOUD_MALL_SHOP ? "Blank" : "blank",
				desc: { bHeight: 24 },
			},
		]);
	}

	// 添加文字标题
	text() {
		const tName = this.data.filter((v) => v.fieldType === "text").length + 1;
		const item = {
			sort: this.data.length,
			_key: uuid4(),
			isActived: false,
			sgwpId: 8,
			ygswpId: 0,
			fieldType: "text",
			desc: {
				// title: this.getPageName() + "文字标题" + tName,
				title: "文字标题",
				titleSize: 28,
				titleStyle: [],
				titleColor: "#000",
				content: "",
				contentSize: 28,
				contentStyle: [],
				contentColor: "#000",
				margin: 24,
			},
		};
		this.addItem(this.insertBlank([item]));
	}

	// 添加橱窗
	ShowWindow() {
		const wName = this.data.filter((v) => v.fieldType === "ShowWindow" || v.fieldType === "ShowWindowGroup").length + 1;
		const item = {
			isActived: false,
			sort: this.data.length,
			_key: uuid4(),
			sgwpId: 1,
			ygswpId: 0,
			fieldType: "ShowWindow",
			desc: {
				caseStyle: 1,
				caseName: "商品橱窗",
				// caseName: this.getPageName() + "商品橱窗" + wName,
				caseNum: 4,
				style: [],
				fontSize: 28,
				caseGroup: [
					{
						sgwpId: 0,
						sort: 1,
						caseName: "",
						caseType: 1,
						productCodes: [],
						productSort: 1,
						classList: [],
						productList: [],
					},
				],
				caseType: 3,
				productCodes: "",
				vAttributeValues: [],
				classList: [],
				productSort: 1,
				productList: [],
				isShowMore: 1,
			},
		};
		this.addItem(this.insertBlank([item]));
	}

	// 添加多页橱窗
	weiGroup() {
		const item = {
			isActived: false,
			sort: this.data.length,
			ygswpId: 0,
			fieldType: "weiGroup",
			desc: {
				weiGroupList: [
					{
						title: "",
						caseType: 4,
						pageId: null,
						_pageName: "",
					},
				],
			},
		};
		this.addItem(this.insertBlank([item]));
	}

	// 添加期刊橱窗
	QiKanShowWindow() {
		const wName = this.data.filter((v) => v.fieldType === "QiKanShowWindow").length + 1;
		const item = {
			isActived: false,
			sort: this.data.length,
			_key: uuid4(),
			sgwpId: 1,
			ygswpId: 0,
			fieldType: "QiKanShowWindow",
			desc: {
				qiKanStyle: 1,
				qiKanName: "期刊橱窗",
				// qiKanName: this.getPageName() + "期刊橱窗" + wName,
				qiKanNum: 4,
				style: [],
				qiKanSize: 28,
				qiKanType: 1,
				list: [],
			},
		};
		this.addItem(this.insertBlank([item]));
	}

	// 添加搜索
	search() {
		const item = {
			sort: this.data.length,
			_key: uuid4(),
			isActived: false,
			sgwpId: 5,
			ygswpId: 0,
			fieldType: "search",
			desc: {
				margin: 24,
				keywords: [],
			},
		};
		this.addItem(this.insertBlank([item]));
	}

	// 添加分类导航
	LabelClass() {
		const item = {
			sort: this.data.length,
			_key: uuid4(),
			isActived: false,
			sqwpId: 0,
			ygswpId: 0,
			fieldType: "LabelClass",
			desc: {
				showClassType: 1,
				list: [
					// {
					//   classId: 0,
					//   isAllClass: 1,
					//   className: "全部",
					//   classPic: "",
					//   parentId: 0,
					//   relationClass: "",
					//   relationList: [],
					// },
				],
			},
		};
		this.addItem(this.insertBlank([item]));
	}

	// 添加图标导航
	iconMenu() {
		const item = {
			sort: this.data.length,
			_key: uuid4(),
			isActived: false,
			sgwpId: 5,
			ygswpId: 0,
			fieldType: "iconMenu",
			desc: {
				type: 1,
				margin: 0,
				borderRadius: 0,
				backGround: "#fff",
				list: [],
			},
		};
		this.addItem(this.insertBlank([item]));
	}

	// 添加悬浮图标
	HoverIcon() {
		let item = {};
		if (!this.data.find((v) => v.fieldType === "HoverIcon")) {
			item = {
				sort: this.data.length,
				_key: uuid4(),
				fieldType: "HoverIcon",
				isActived: true,
				desc: {
					list: [
						{
							title: "联系导购",
							url: "https://ssl-picture.tenyun.runsasoft.com/shouye-lianxidaogou.png",
							page: 4,
							pageId: "",
							pageName: "",
						},
					],
				},
			};
			this.data = this.data.map((v) => {
				v.isActived = false;
				return v;
			});
			this.addItem([item]);
		} else {
			this.data = this.data.map((v) => {
				v.isActived = v.fieldType === "HoverIcon";
				return v;
			});
			this.$emit("input", this.data);
		}
	}

	//  商品图片
	ProductPicture() {
		const item = {
			sgmpId: 0,
			fieldType: "ProductPicture",
			isActived: false,
			position: 5,
			desc: {
				imageUrl: "",
			},
		};
		this.addItem([item]);
	}

	// 添加引导
	guide() {
		const index = this.data.findIndex((v) => v.fieldType === "guide");
		if (index > -1) {
			this.data = this.data.map((v, i) => {
				v.isActived = i === index;
				return v;
			});
			this.$emit("input", this.data);
		} else {
			const item = {
				sgmpId: 0,
				fieldType: "guide",
				isActived: false,
				desc: {
					guideContent: "",
				},
			};
			this.addItem([item]);
		}
	}

	// 添加微页面视频
	pageVideo() {
		const item = {
			sort: this.data.length,
			isActived: false,
			sgmpId: 0,
			fieldType: "pageVideo",
			desc: {
				videoSource: 1,
				videoUrl: "",
				isAutoPlay: 0,
			},
		};
		this.addItem(this.insertBlank([item]));
	}

	// 添加图片
	picture() {
		const item = {
			sort: this.data.length,
			_key: uuid4(),
			isActived: false,
			sgmpId: 0,
			fieldType: "picture",
			desc: {
				pictureUrl: "",
			},
		};
		this.addItem(this.insertBlank([item]));
	}

	// 结果提交至父级
	addItem(val) {
		this.$emit("add", val);
	}

	onAdd(key) {
		this[key]();
	}

	// 微页面设置按钮选中
	onActive() {
		this.data = this.data.map((v, i) => {
			v.isActived = i === 0;
			return v;
		});
		this.$emit("input", this.data);
	}

	render(h) {
		const showButtonList = ButtonList.filter((v) => !!v.page.includes(this.fromPage));
		return this.fromPage ? (
			<div>
				{showButtonList.map((buttonItem) => {
					const funcKey = buttonItem.key === "miniPage" ? "onActive" : "onAdd";
					return (
						<div class={[buttonItem.key === "miniPage" && this.data[0] && this.data[0].isActived && "is-actived", this.fromPage === 1 || this.fromPage === 2 ? "addButton" : "add-button"]} onClick={this[funcKey].bind(this, buttonItem.key)}>
							{this.fromPage == 1 || this.fromPage == 2 ? <i class={["iconfont font-size-48 line-height-48", buttonItem.icon]}></i> : ""}

							<span class={{ "line-height-24": this.fromPage === 1 || this.fromPage === 2 }}>{buttonItem.text}</span>
						</div>
					);
				})}
			</div>
		) : (
			""
		);
	}
}
